import { IntlShape } from 'react-intl';
import { ModuleHierachy } from '../../common/module/types';
import { isPermitted } from 'src/app/common/utils';
import {
  AdminProspectReferralPermissionType,
  PROSPECT_REFERRAL_BASE_PATH,
  PROSPECT_REFERRAL_NAMESPACE,
  PROSPECT_REFERRAL_TITLE,
} from './constants';
import ProspectReferralRoutes from './pages/prospectReferralRoutes';

export const prospectReferralModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  const Translation = (id: string) => intl.formatMessage({ id });
  return {
    title: Translation(PROSPECT_REFERRAL_TITLE),
    path: PROSPECT_REFERRAL_BASE_PATH,
    namespace: PROSPECT_REFERRAL_NAMESPACE,
    component: ProspectReferralRoutes,
    enableRead: isPermitted(
      [
        AdminProspectReferralPermissionType.PROSPECT_REFERRAL_READ,
        AdminProspectReferralPermissionType.PROSPECT_REFERRAL_CREATE,
        AdminProspectReferralPermissionType.PROSPECT_REFERRAL_UPDATE,
      ],
      permissions,
    ),
    enableCreate: isPermitted([AdminProspectReferralPermissionType.PROSPECT_REFERRAL_CREATE], permissions),
    enableUpdate: isPermitted([AdminProspectReferralPermissionType.PROSPECT_REFERRAL_UPDATE], permissions),
  };
};
